import { render, staticRenderFns } from "./add-template.vue?vue&type=template&id=a4358444&scoped=true"
import script from "./add-template.vue?vue&type=script&lang=js"
export * from "./add-template.vue?vue&type=script&lang=js"
import style0 from "./add-template.vue?vue&type=style&index=0&id=a4358444&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4358444",
  null
  
)

export default component.exports